
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("62Ykk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bfbaf7ed1e651617$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $bfbaf7ed1e651617$export$2e2bcd8739ae039 = {
    'fabric.emoji.add.custom.emoji.label': 'Add your own emoji',
    'fabric.emoji.add.label': 'Add emoji',
    'fabric.emoji.cancel.label': 'Cancel',
    'fabric.emoji.categories.label': 'Choose an emoji category',
    'fabric.emoji.categories.search.results': 'Search results',
    'fabric.emoji.category.activity': 'Activity',
    'fabric.emoji.category.all.uploads': 'All uploads',
    'fabric.emoji.category.flags': 'Flags',
    'fabric.emoji.category.foods': 'Food & Drink',
    'fabric.emoji.category.frequent': 'Frequent',
    'fabric.emoji.category.nature': 'Nature',
    'fabric.emoji.category.objects': 'Objects',
    'fabric.emoji.category.people': 'People',
    'fabric.emoji.category.places': 'Travel & Places',
    'fabric.emoji.category.productivity': 'Productivity',
    'fabric.emoji.category.symbols': 'Symbols',
    'fabric.emoji.category.user.uploads': 'Your uploads',
    'fabric.emoji.choose.file.screenReaderDescription': 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
    'fabric.emoji.choose.file.title': 'Choose file',
    'fabric.emoji.delete.description': 'All existing instances of this emoji will be replaced with {emojiShortName}',
    'fabric.emoji.delete.label': 'Remove',
    'fabric.emoji.delete.screenreader.tooltip': 'To delete {shortName} emoji, press Backspace',
    'fabric.emoji.delete.title': 'Remove emoji',
    'fabric.emoji.delete.tooltip': 'Delete',
    'fabric.emoji.emojipicker.emoi.roledescription': 'emoji button',
    'fabric.emoji.emojipicker.error': 'Error!',
    'fabric.emoji.error.delete.failed': 'Remove failed',
    'fabric.emoji.error.image.too.big': 'Selected image is more than 1 MB',
    'fabric.emoji.error.invalid.image': 'Selected image is invalid',
    'fabric.emoji.error.upload.failed': 'Upload failed',
    'fabric.emoji.error.upload.timeout': 'Upload timed out',
    'fabric.emoji.image.requirements': 'JPG, PNG or GIF. Max size 1 MB.',
    'fabric.emoji.name.ariaLabel': 'Enter a name for the new emoji',
    'fabric.emoji.picker': 'Emoji picker',
    'fabric.emoji.pickerlist.grid': '{showSearchResults, select, true{Search results} other{Emojis}}',
    'fabric.emoji.pickerlist.tabpanel': 'Emojis actions and list panel',
    'fabric.emoji.placeholder': 'e.g. hello',
    'fabric.emoji.preview': 'Your new emoji {emoji} looks great',
    'fabric.emoji.preview.title': 'Preview',
    'fabric.emoji.retry.label': 'Retry',
    'fabric.emoji.search.label': 'Emoji name',
    'fabric.emoji.search.placeholder': 'Search',
    'fabric.emoji.search.status': 'Seeing all emojis',
    'fabric.emoji.select.skin.list.ariaLabel': 'Skin tone selector',
    'fabric.emoji.select.skin.tone.ariaLabel': 'Choose your skin tone, {selectedTone} selected'
};

});


//# sourceMappingURL=en.1e992e70.js.map
